<template>
  <!-- Компонент ничего не рендерит -->
</template>

<script>
import { onMounted, onUnmounted } from 'vue'
import { Tooltip } from 'bootstrap'

// Короткая задержка: подсказка не мелькает при движении мыши, но и не ждёт, как title браузера
const SHOW_DELAY = 150

export default {
  name: 'TooltipProvider',
  setup() {
    const instances = new Map()

    // На сенсорных экранах наведения нет: подсказка по касанию «залипает»
    const canHover = window.matchMedia?.('(hover: hover)').matches ?? true

    const create = (el) => {
      if (!canHover || !el.dataset.tooltip || instances.has(el)) return
      const tooltip = new Tooltip(el, {
        title: el.dataset.tooltip,
        placement: el.dataset.tooltipPosition || 'top',
        trigger: 'hover focus',
        container: 'body',
        boundary: 'window',
        delay: { show: SHOW_DELAY, hide: 0 },
        customClass: 'np-tooltip',
      })
      // клик открывает меню или окно — подсказка над ним не нужна
      const hide = () => tooltip.hide()
      el.addEventListener('click', hide)
      instances.set(el, { tooltip, hide })
    }

    const dispose = (el) => {
      const entry = instances.get(el)
      if (!entry) return
      el.removeEventListener('click', entry.hide)
      entry.tooltip.dispose()
      instances.delete(el)
    }

    // Текст сменился (язык, счётчик) — обновить, а не показывать старый
    const update = (el) => {
      const entry = instances.get(el)
      if (!el.dataset.tooltip) { dispose(el); return }
      if (!entry) { create(el); return }
      entry.tooltip.setContent({ '.tooltip-inner': el.dataset.tooltip })
    }

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'attributes') {
          update(m.target)
          continue
        }
        for (const node of m.addedNodes) {
          if (node.nodeType === 1) {
            if (node.matches?.('[data-tooltip]')) create(node)
            node.querySelectorAll?.('[data-tooltip]').forEach(create)
          }
        }
        for (const node of m.removedNodes) {
          if (node.nodeType === 1) {
            if (node.matches?.('[data-tooltip]')) dispose(node)
            node.querySelectorAll?.('[data-tooltip]').forEach(dispose)
          }
        }
      }
    })

    onMounted(() => {
      document.querySelectorAll('[data-tooltip]').forEach(create)
      observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-tooltip'] })
    })

    onUnmounted(() => {
      observer.disconnect()
      instances.forEach((entry, el) => dispose(el))
    })

    return {}
  }
}
</script>